<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-page-header content="支付流水上传"></el-page-header>
    </el-breadcrumb>
    <el-card class="box-card" style="margin-top:20px">
      <div class="container">
        <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-bottom: 20px;">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>财务管理</el-breadcrumb-item>
          <el-breadcrumb-item>支付流水上传与保存</el-breadcrumb-item>
        </el-breadcrumb>

        <div class="header">
          <h1>支付流水数据保存系统</h1>
          <p>注意：请选择正确的代理、支付通道、支付月份。上传Excel/CSV文件并通过API接口保存数据</p>
          <div class="performance-tips">
            <el-alert
                    title="大文件处理提示"
                    type="info"
                    :closable="false"
                    description="超过10万条记录的大文件建议使用分片上传或分批处理，系统会自动进行性能优化">
            </el-alert>
          </div>
        </div>

        <div>
          <el-form :model="form" :rules="rules" ref="form" label-width="120px" size="mini">
            <el-form-item label="所属代理商" required>
              <el-input placeholder="请选择所属代理商" v-model="form.proxy_name" :readonly="true" @click.native="cProxy" clearable type="text">
                <i slot="suffix" class="el-icon-more"></i>
              </el-input>
            </el-form-item>
            <el-form-item required label="支付月份">
              <el-date-picker
                      v-model="form.pay_time"
                      type="month"
                      placeholder="请选择支付月份">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="所属支付渠道" required>
              <el-select
                      v-model="form.pay_source_id"
                      placeholder="请选择所属支付渠道"
                      @change="changeRoleNameValue($event)"
              >
                <el-option v-for="item in paySourceList"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button @click="okForm" type="primary" icon="el-icon-edit">确认选择</el-button>
            </el-form-item>
          </el-form>
        </div>

        <div class="main-content" v-if="is_show">
          <!-- 性能模式选择 -->
          <div class="performance-mode" v-if="!file">
            <div class="section-title">
              <i class="el-icon-setting"></i>
              处理模式选择
            </div>
            <el-radio-group v-model="performanceMode" size="medium">
              <el-radio-button label="standard">标准模式</el-radio-button>
              <el-radio-button label="large-file">大文件模式</el-radio-button>
              <el-radio-button label="chunk-upload">分片上传模式</el-radio-button>
            </el-radio-group>
            <div class="mode-description">
              <div v-if="performanceMode === 'standard'">
                <p>• 适合10万条以下数据</p>
                <p>• 内存占用较小</p>
                <p>• 全量数据预览</p>
              </div>
              <div v-if="performanceMode === 'large-file'">
                <p>• 适合10-50万条数据</p>
                <p>• 流式处理，降低内存占用</p>
                <p>• 分批上传，自动重试</p>
              </div>
              <div v-if="performanceMode === 'chunk-upload'">
                <p>• 适合50万条以上超大数据</p>
                <p>• 文件分片上传</p>
                <p>• 断点续传支持</p>
                <p>• 后台异步处理</p>
              </div>
            </div>
          </div>

          <!-- 上传区域 -->
          <div class="upload-section">
            <div class="section-title">
              <i class="el-icon-upload"></i>
              文件上传
            </div>

            <div class="file-type-tabs">
              <div class="file-type-tab" :class="{active: activeTab === 'excel'}" @click="activeTab = 'excel'">Excel上传</div>
              <div class="file-type-tab" :class="{active: activeTab === 'csv'}" @click="activeTab = 'csv'">CSV上传</div>
            </div>

            <!-- 大文件模式的上传组件 -->
            <div v-if="performanceMode === 'chunk-upload'">
              <el-upload
                      class="upload-demo"
                      drag
                      action="#"
                      :auto-upload="false"
                      :on-change="handleLargeFileChange"
                      :accept="activeTab === 'excel' ? '.xlsx, .xls' : '.csv'"
                      :limit="1"
                      :file-list="fileList"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将{{activeTab === 'excel' ? 'Excel' : 'CSV'}}文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">支持分片上传，最大支持2GB文件</div>
              </el-upload>

              <!-- 分片上传进度 -->
              <div v-if="chunkUploading" class="chunk-progress">
                <el-progress  :percentage="Number(chunkProgress)"   :stroke-width="16">
                  <template >
                    <span class="percentage-text">{{ chunkProgress }}%</span>
                    <span class="chunk-info">分片 {{ currentChunk }}/{{ totalChunks }}</span>
                  </template>
                </el-progress>
                <div class="chunk-details">
                  <span>速度: {{ formatSpeed(uploadSpeed) }}</span>
                  <span>剩余时间: {{ formatTime(estimatedTime) }}</span>
                  <span>已上传: {{ formatFileSize(uploadedSize) }}/{{ formatFileSize(file.size) }}</span>
                </div>
              </div>
            </div>

            <!-- 标准和大文件模式 -->
            <div v-else>
              <el-upload
                      class="upload-demo"
                      drag
                      action="#"
                      :auto-upload="false"
                      :on-change="handleFileChange"
                      :accept="activeTab === 'excel' ? '.xlsx, .xls' : '.csv'"
                      :limit="1"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将{{activeTab === 'excel' ? 'Excel' : 'CSV'}}文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">支持{{activeTab === 'excel' ? 'xlsx、xls' : 'csv'}}格式文件</div>
              </el-upload>
            </div>

            <!-- 大文件处理参数 -->
            <div v-if="performanceMode !== 'standard' && file" class="large-file-config">
              <el-collapse v-model="activeConfigPanel">
                <el-collapse-item title="大文件处理参数" name="1">
                  <div class="config-row">
                    <span class="config-label">每批处理数量：</span>
                    <el-input-number
                            v-model="batchSize"
                            :min="100"
                            :max="5000"
                            :step="100"
                            controls-position="right"
                    ></el-input-number>
                    <span class="config-tip">建议1000-2000条/批</span>
                  </div>
                  <div class="config-row">
                    <span class="config-label">失败重试次数：</span>
                    <el-input-number
                            v-model="retryCount"
                            :min="0"
                            :max="5"
                            controls-position="right"
                    ></el-input-number>
                  </div>
                  <div class="config-row">
                    <span class="config-label">请求超时时间：</span>
                    <el-input-number
                            v-model="requestTimeout"
                            :min="10"
                            :max="120"
                            controls-position="right"
                    >
                      <template slot="append">秒</template>
                    </el-input-number>
                  </div>
                  <div class="config-row">
                    <el-checkbox v-model="enableParallel">启用并行处理</el-checkbox>
                    <el-checkbox v-model="enableCompression">启用数据压缩</el-checkbox>
                  </div>
                </el-collapse-item>
              </el-collapse>
            </div>

            <div class="upload-tips">
              <p>上传说明：</p>
              <p>1. 请确保文件包含支付流水数据</p>
              <p>2. 第一行应为表头（字段名称）</p>
              <p>3. 系统将自动映射到API字段</p>
              <p>4. 支持数据验证和错误处理</p>
            </div>

            <div v-if="file" class="file-info">
              <p>已选择文件: {{ file.name }}</p>
              <p>文件大小: {{ formatFileSize(file.size) }}</p>
              <p>文件类型: {{ file.type || getFileType(file.name) }}</p>
              <p v-if="performanceMode === 'standard'">检测到字段: {{ tableHeader.length }} 个</p>
              <p v-if="performanceMode === 'large-file' && estimatedRowCount">预计数据量: {{ estimatedRowCount.toLocaleString() }} 条</p>
            </div>

            <div class="action-buttons">
              <el-button
                      type="primary"
                      icon="el-icon-upload"
                      @click="processFile"
                      :disabled="!file || processingFile"
                      :loading="processingFile"
              >
                {{ processingFile ? '处理中...' : '处理文件' }}
              </el-button>
              <el-button icon="el-icon-delete" @click="clearData">
                清空数据
              </el-button>
              <el-button
                      v-if="file && performanceMode === 'large-file'"
                      @click="estimateFileSize"
                      icon="el-icon-search"
              >
                估算数据量
              </el-button>
            </div>

            <!-- 内存监控 -->
            <div v-if="performanceMode !== 'standard' && processingFile" class="memory-monitor">
              <div class="memory-info">
                <span>内存使用: {{ memoryUsage }} MB</span>
                <el-progress   :percentage="Number(memoryPercentage)"  :show-text="false" :stroke-width="8"></el-progress>
              </div>
            </div>

            <div v-if="uploadSuccess" class="success-message">
              <i class="el-icon-success"></i>
              <span>文件处理成功！共解析 {{ tableData.length }} 条数据</span>
            </div>
          </div>

          <!-- 预览区域 -->
          <div class="preview-section">
            <div class="section-title">
              <i class="el-icon-document"></i>
              数据预览
            </div>

            <div v-if="tableData.length === 0" class="no-data">
              <i class="el-icon-document"></i>
              <p>暂无数据，请上传{{activeTab === 'excel' ? 'Excel' : 'CSV'}}文件</p>
            </div>

            <div v-else>
              <div v-if="performanceMode === 'large-file'" class="streaming-notice">
                <el-alert
                        title="流式处理模式"
                        type="info"
                        description="当前为大文件流式处理模式，仅显示部分数据预览"
                        :closable="false">
                </el-alert>
              </div>

              <el-table
                      :data="previewData"
                      border
                      stripe
                      class="preview-table"
                      max-height="300"
                      v-loading="loadingPreview"
              >
                <el-table-column
                        v-for="(header, index) in tableHeader"
                        :key="index"
                        :prop="header"
                        :label="header"
                        min-width="120"
                        show-overflow-tooltip
                >
                </el-table-column>
              </el-table>

              <div style="margin-top: 15px; text-align: center; color: #909399;" v-if="tableData.length > previewLimit">
                仅显示前{{ previewLimit }}条记录，共 {{ tableData.length }} 条记录
              </div>

              <div class="action-buttons">
                <el-button
                        type="primary"
                        icon="el-icon-download"
                        @click="exportData"
                        :loading="exporting"
                        :disabled="exporting"
                >
                  {{ exporting ? '导出中...' : '导出数据' }}
                </el-button>
                <el-button type="success" icon="el-icon-check" @click="showMappingDialog">
                  配置API映射
                </el-button>
              </div>
            </div>
          </div>

          <!-- API操作区域 -->
          <div class="api-section">
            <div class="section-title">
              <i class="el-icon-connection"></i>
              API接口操作
            </div>

            <!-- 性能监控 -->
            <div class="performance-monitor" v-if="saving || performanceMode !== 'standard'">
              <div class="monitor-row">
                <span>处理速度:</span>
                <span class="monitor-value">{{ processingSpeed.toFixed(1) }} 条/秒</span>
              </div>
              <div class="monitor-row">
                <span>成功率:</span>
                <span class="monitor-value">{{ successRate }}%</span>
              </div>
              <div class="monitor-row">
                <span>重试次数:</span>
                <span class="monitor-value">{{ totalRetries }}</span>
              </div>
            </div>

            <div class="api-status">
              <div class="status-indicator" :class="apiConnected ? 'status-connected' : 'status-disconnected'"></div>
              <span v-if="apiConnected">API连接正常 (v1.2.0)</span>
              <span v-else>API未连接</span>
              <el-button size="mini" :type="apiConnected ? 'danger' : 'success'" @click="toggleApiConnection" style="margin-left: auto;">
                {{ apiConnected ? '断开连接' : '连接API' }}
              </el-button>
            </div>

            <div class="api-stats" v-if="apiConnected">
              <div class="stat-card">
                <div class="stat-label">总请求数</div>
                <div class="stat-value">{{ apiStats.totalRequests }}</div>
              </div>
              <div class="stat-card">
                <div class="stat-label">成功请求</div>
                <div class="stat-value">{{ apiStats.successRequests }}</div>
              </div>
              <div class="stat-card">
                <div class="stat-label">失败请求</div>
                <div class="stat-value" :style="{color: apiStats.failedRequests > 0 ? '#f56c6c' : '#67c23a'}">{{ apiStats.failedRequests }}</div>
              </div>
              <div class="stat-card">
                <div class="stat-label">平均响应时间</div>
                <div class="stat-value">{{ apiStats.avgResponseTime }}ms</div>
              </div>
            </div>

            <!-- 失败重试管理 -->
            <div v-if="failedRecords.length > 0" class="failed-records">
              <el-alert
                      title="存在失败记录"
                      type="warning"
                      :description="`共 ${failedRecords.length} 条记录保存失败，点击重试`"
                      show-icon>
              </el-alert>
              <el-button
                      size="small"
                      type="warning"
                      icon="el-icon-refresh"
                      @click="retryFailedRecords"
                      :loading="retryingFailed"
                      style="margin-top: 10px;"
              >
                重试失败记录
              </el-button>
            </div>

            <div class="api-operations" v-if="apiConnected && tableData.length > 0">
              <el-button type="primary" icon="el-icon-edit" @click="showMappingDialog">
                字段映射配置
              </el-button>
              <el-button
                      type="success"
                      icon="el-icon-upload"
                      @click="saveViaApi"
                      :loading="saving"
                      :disabled="saving || tableData.length === 0"
              >
                {{ saving ? `保存中 (${processedRecords}/${tableData.length})` : '通过API保存数据' }}
              </el-button>
              <el-button
                      type="warning"
                      icon="el-icon-view"
                      @click="testApi"
                      :disabled="saving"
              >
                测试API接口
              </el-button>
            </div>

            <!-- 分阶段进度 -->
            <div v-if="saving" class="phase-progress">
              <div class="phase-title">处理阶段</div>
              <el-steps :active="currentPhase" align-center>
                <el-step title="数据准备" :description="`${processedRecords}/${tableData.length}`"></el-step>
                <el-step title="批量上传" :description="`${currentBatch}/${totalBatches}`"></el-step>
                <el-step title="数据校验" description="进行中"></el-step>
                <el-step title="完成保存" description="等待中"></el-step>
              </el-steps>
            </div>

            <div class="api-progress" v-if="saving">
              <el-progress
                      :percentage="Number(saveProgress)"
                      :stroke-width="16"
                      :status="saveProgress === 100 ? 'success' : undefined"
              >
                <template >
                  <span class="progress-text">
                    进度: {{ saveProgress }}% |
                    已处理: {{ processedRecords.toLocaleString() }} 条 |
                    成功率: {{ ((processedRecords - failedRecords.length) / processedRecords * 100).toFixed(1) }}%
                  </span>
                </template>
              </el-progress>
            </div>

            <div class="response-details" v-if="apiResponse">
              <h3>API响应详情</h3>
              <div class="response-item" :class="{'response-error': apiResponse.status === 'error'}">
                <p><strong>状态:</strong> {{ apiResponse.status }}</p>
                <p><strong>消息:</strong> {{ apiResponse.message }}</p>
                <p v-if="apiResponse.data"><strong>数据:</strong> {{ apiResponse.data.processed }} 条记录已处理</p>
                <p v-if="apiResponse.data"><strong>成功:</strong> {{ apiResponse.data.success }} 条</p>
                <p v-if="apiResponse.data"><strong>失败:</strong> {{ apiResponse.data.failed }} 条</p>
                <p><strong>处理时间:</strong> {{ formatDuration(processingDuration) }}</p>
              </div>
            </div>

            <!-- 详细错误日志 -->
            <div v-if="errorDetails.length > 0" class="error-details">
              <el-collapse>
                <el-collapse-item title="详细错误信息">
                  <div v-for="(error, index) in errorDetails" :key="index" class="error-item">
                    <p><strong>记录 {{ error.index + 1 }}:</strong> {{ error.message }}</p>
                    <p v-if="error.data">数据: {{ JSON.stringify(error.data) }}</p>
                  </div>
                </el-collapse-item>
              </el-collapse>
            </div>

            <div class="api-log">
              <div v-for="(log, index) in apiLogs" :key="index" class="log-entry" :class="{'log-error': log.type === 'error', 'log-warning': log.type === 'warning'}">
                [{{ log.time }}] {{ log.message }}
              </div>
              <div v-if="apiLogs.length === 0" style="color: #909399; text-align: center; padding: 20px;">
                暂无API日志
              </div>
            </div>
          </div>
        </div>

        <div class="footer">
          <p>© 2025 支付流水数据保存系统 | API版本: v1.2.0 | 性能优化版本</p>
        </div>
      </div>

      <!-- 字段映射对话框 -->
      <el-dialog title="字段映射配置" :visible.sync="mappingDialogVisible" width="800px">
        <div class="data-mapping">
          <p>请将上传文件的字段映射到API接口字段：</p>

          <div v-for="(header, index) in tableHeader" :key="index" class="mapping-row">
            <div class="source-field">{{ header }}</div>
            <div class="mapping-arrow"><i class="el-icon-right"></i></div>
            <el-select v-model="fieldMappings[header]" placeholder="选择API字段" class="target-field">
              <el-option v-for="field in apiFields" :key="field" :label="field" :value="field"></el-option>
            </el-select>
          </div>

          <el-divider></el-divider>

          <h4>API端点配置</h4>
          <el-input v-model="apiEndpoint" placeholder="请输入API端点URL" style="margin-bottom: 15px;">
            <template slot="prepend">API URL</template>
          </el-input>

          <el-input v-model="apiBatchSize" placeholder="请输入批量大小" style="margin-bottom: 15px;">
            <template slot="prepend">批量大小</template>
            <template slot="append">条/请求</template>
          </el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="mappingDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="confirmMapping">确认配置</el-button>
        </span>
      </el-dialog>
    </el-card>

    <eProxyList
            :formData="formData2"
            :visible.sync="visible2"
            :title="title2"
            v-on:eventChoose="chooseProxy"
            :closeForm="closeForm2"
    />
  </div>
</template>

<script>
  import eProxyList from "../../common/eProxyList"
  import Papa from 'papaparse';
  import * as XLSX from 'xlsx';

  export default {
    name: 'uploadPayCsv',
    components: { eProxyList },
    data() {
      return {
        is_show: false,
        paySourceList: [],
        formData2: { pid: '' },
        title2: '',
        visible2: false,
        form: {
          proxy_id: '',
          proxy_name: '',
          pay_source_id: '',
          pay_time: ''
        },
        rules: {},

        // 性能优化相关
        performanceMode: 'standard', // standard, large-file, chunk-upload
        processingFile: false,
        exporting: false,
        loadingPreview: false,
        previewLimit: 100,
        batchSize: 1000,
        retryCount: 3,
        requestTimeout: 30,
        enableParallel: true,
        enableCompression: true,
        activeConfigPanel: ['1'],

        // 分片上传相关
        fileList: [],
        chunkUploading: false,
        chunkProgress: 0,
        currentChunk: 0,
        totalChunks: 0,
        uploadSpeed: 0,
        estimatedTime: 0,
        uploadedSize: 0,

        // 性能监控
        memoryUsage: 0,
        memoryPercentage: 0,
        estimatedRowCount: 0,
        processingSpeed: 0,
        successRate: 100,
        totalRetries: 0,
        processingDuration: 0,
        currentPhase: 1,

        // 失败重试
        failedRecords: [],
        retryingFailed: false,
        errorDetails: [],

        // 原有数据
        file: null,
        tableHeader: [],
        tableData: [],
        uploadSuccess: false,
        activeTab: 'excel',
        apiConnected: true,
        apiStats: {
          totalRequests: 0,
          successRequests: 0,
          failedRequests: 0,
          avgResponseTime: 0
        },
        saving: false,
        saveProgress: 0,
        processedRecords: 0,
        currentBatch: 0,
        totalBatches: 0,
        apiLogs: [],
        mappingDialogVisible: false,
        fieldMappings: {},
        apiFields: [
          'cusid', 'service_cusid', 'balance', 'servince_name','product_type',
          'merchant', 'paymentMethod', 'customerId','merchant_name',
          'orderId', 'description', 'fee', 'netAmount','amount','trade_time','way_code'
        ],
        apiEndpoint: '/api/payment/save',
        apiBatchSize: 50,
        apiResponse: null
      }
    },
    computed: {
      previewData() {
        // 大文件模式只显示前previewLimit条数据
        if (this.performanceMode === 'large-file') {
          return this.tableData.slice(0, this.previewLimit);
        }
        return this.tableData.slice(0, 5);
      }
    },
    created() {
      this.getProxyList();
      this.startMemoryMonitoring();
    },
    methods: {
      // 性能优化方法
      startMemoryMonitoring() {
        setInterval(() => {
          if (typeof performance !== 'undefined' && performance.memory) {
            this.memoryUsage = (performance.memory.usedJSHeapSize / 1024 / 1024).toFixed(2);
            this.memoryPercentage = (performance.memory.usedJSHeapSize / performance.memory.totalJSHeapSize * 100).toFixed(1);
          }
        }, 1000);
      },

      // 大文件处理
      async handleLargeFileChange(file) {
        this.file = file.raw;
        this.uploadSuccess = false;
        this.tableData = [];
        this.tableHeader = [];

        if (!this.file) {
          this.$message.error('请选择文件');
          return;
        }

        if (this.file.size > 100 * 1024 * 1024) { // 超过100MB
          this.$confirm('检测到大文件，建议使用分片上传模式，是否继续？', '提示', {
            confirmButtonText: '继续',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.parseLargeFile();
          }).catch(() => {
            this.file = null;
          });
        } else {
          this.parseLargeFile();
        }
      },

      async parseLargeFile() {
        this.processingFile = true;
        const startTime = Date.now();

        try {
          if (this.activeTab === 'csv') {
            await this.parseCSVStream();
          } else {
            await this.parseExcelStream();
          }

          const duration = (Date.now() - startTime) / 1000;
          this.processingSpeed = this.tableData.length / duration;

          this.$message.success(`文件解析完成，共 ${this.tableData.length.toLocaleString()} 条记录，耗时 ${duration.toFixed(1)} 秒`);
          this.addApiLog(`大文件解析完成: ${this.tableData.length} 条记录`, 'info');

        } catch (error) {
          this.$message.error(`文件解析失败: ${error.message}`);
          this.addApiLog(`大文件解析失败: ${error.message}`, 'error');
        } finally {
          this.processingFile = false;
        }
      },

      async parseCSVStream() {
        return new Promise((resolve, reject) => {
          let rowCount = 0;
          const chunkSize = 10000;

          Papa.parse(this.file, {
            header: true,
            skipEmptyLines: true,
            chunkSize: chunkSize,
            chunk: (results, parser) => {
              if (rowCount === 0) {
                this.tableHeader = results.meta.fields;
                this.initFieldMappings();
              }

              // 流式处理，只保留部分数据在内存中
              if (rowCount < this.previewLimit) {
                this.tableData.push(...results.data);
              }
              rowCount += results.data.length;

              // 显示进度
              if (rowCount % chunkSize === 0) {
                this.$message.info(`已解析 ${rowCount.toLocaleString()} 条记录...`);
              }

              // 大文件只记录数量，不保存全部数据
              if (rowCount > this.previewLimit * 10) {
                parser.abort();
                this.tableData = this.tableData.slice(0, this.previewLimit);
                this.estimatedRowCount = rowCount;
                resolve();
              }
            },
            complete: () => {
              this.uploadSuccess = true;
              this.estimatedRowCount = rowCount;
              resolve();
            },
            error: (error) => {
              reject(error);
            }
          });
        });
      },

      async parseExcelStream() {
        const reader = new FileReader();

        return new Promise((resolve, reject) => {
          reader.onload = async (e) => {
            try {
              const data = new Uint8Array(e.target.result);
              const workbook = XLSX.read(data, {
                type: 'array',
                cellDates: true,
                cellNF: false,
                cellText: false
              });

              const firstSheetName = workbook.SheetNames[0];
              const worksheet = workbook.Sheets[firstSheetName];

              // 获取表头
              const range = XLSX.utils.decode_range(worksheet['!ref']);
              this.tableHeader = [];
              for (let C = range.s.c; C <= range.e.c; ++C) {
                const cell = worksheet[XLSX.utils.encode_cell({r: 0, c: C})];
                this.tableHeader.push(cell ? cell.v : `Column${C+1}`);
              }

              this.initFieldMappings();

              // 限制读取行数
              const maxRows = Math.min(range.e.r, this.previewLimit * 10);
              for (let R = 1; R <= maxRows; ++R) {
                const row = {};
                for (let C = range.s.c; C <= range.e.c; ++C) {
                  const cell = worksheet[XLSX.utils.encode_cell({r: R, c: C})];
                  if (cell) {
                    row[this.tableHeader[C]] = cell.v;
                  }
                }
                this.tableData.push(row);

                // 显示进度
                if (R % 10000 === 0) {
                  this.$message.info(`已读取 ${R.toLocaleString()} 行...`);
                }
              }

              this.uploadSuccess = true;
              this.estimatedRowCount = maxRows;
              resolve();

            } catch (error) {
              reject(error);
            }
          };

          reader.onerror = (error) => reject(error);
          reader.readAsArrayBuffer(this.file);
        });
      },

      // 优化后的保存方法
      async saveViaApi() {
        if (this.tableData.length === 0) {
          this.$message.warning('没有数据可保存');
          return;
        }

        if (this.form.pay_source_id === '') {
          this.$message.warning('请选择支付渠道');
          return;
        }

        if (this.form.proxy_id === '') {
          this.$message.warning('请选择代理商');
          return;
        }

        if (!this.form.pay_time) {
          this.$message.warning('请选择支付月份');
          return;
        }

        // 确认大文件操作
        if (this.tableData.length > 100000) {
          await this.$confirm(`检测到 ${this.tableData.length.toLocaleString()} 条记录，处理可能需要较长时间，是否继续？`, '大文件提示', {
            confirmButtonText: '继续',
            cancelButtonText: '取消',
            type: 'warning'
          });
        }

        this.saving = true;
        const startTime = Date.now();

        // 重置统计
        this.apiStats = {
          totalRequests: 0,
          successRequests: 0,
          failedRequests: 0,
          avgResponseTime: 0
        };

        this.failedRecords = [];
        this.errorDetails = [];
        this.totalRetries = 0;
        this.processedRecords = 0;
        this.saveProgress = 0;
        this.currentBatch = 0;
        this.totalBatches = Math.ceil(this.tableData.length / this.batchSize);

        this.addApiLog(`开始保存 ${this.tableData.length} 条记录，分 ${this.totalBatches} 批处理`, 'info');

        try {
          if (this.enableParallel && this.totalBatches > 1) {
            await this.processBatchesParallel();
          } else {
            await this.processBatchesSequential();
          }

          this.processingDuration = (Date.now() - startTime) / 1000;
          this.successRate = ((this.tableData.length - this.failedRecords.length) / this.tableData.length * 100).toFixed(1);

          if (this.failedRecords.length === 0) {
            this.$message.success(`所有数据保存完成！耗时 ${this.processingDuration.toFixed(1)} 秒`);
            this.addApiLog(`所有 ${this.tableData.length} 条记录保存成功`, 'info');
          } else {
            this.$message.warning(`保存完成，${this.failedRecords.length} 条记录失败`);
            this.addApiLog(`${this.tableData.length - this.failedRecords.length} 条成功，${this.failedRecords.length} 条失败`, 'warning');
          }

        } catch (error) {
          this.$message.error(`保存过程出错: ${error.message}`);
          this.addApiLog(`保存过程出错: ${error.message}`, 'error');
        } finally {
          this.saving = false;
          this.currentPhase = 4;
        }
      },

      async processBatchesSequential() {
        for (let i = 0; i < this.totalBatches; i++) {
          this.currentBatch = i + 1;
          this.currentPhase = 2;

          const startIdx = i * this.batchSize;
          const endIdx = Math.min(startIdx + this.batchSize, this.tableData.length);
          const batchData = this.tableData.slice(startIdx, endIdx);

          await this.processBatch(batchData, i);

          this.processedRecords = endIdx;
          this.saveProgress = Math.round((endIdx / this.tableData.length) * 100);

          // 防止内存占用过高，清理已处理的数据（大文件模式）
          if (this.performanceMode === 'large-file' && i % 10 === 0) {
            await new Promise(resolve => setTimeout(resolve, 100));
          }
        }
      },

      async processBatchesParallel() {
        const concurrentLimit = 3; // 并发限制
        const batches = [];

        for (let i = 0; i < this.totalBatches; i++) {
          const startIdx = i * this.batchSize;
          const endIdx = Math.min(startIdx + this.batchSize, this.tableData.length);
          const batchData = this.tableData.slice(startIdx, endIdx);
          batches.push({ index: i, data: batchData });
        }

        // 并发处理
        for (let i = 0; i < batches.length; i += concurrentLimit) {
          const chunk = batches.slice(i, i + concurrentLimit);
          this.currentPhase = 2;

          await Promise.all(chunk.map(async (batch) => {
            await this.processBatch(batch.data, batch.index);
          }));

          this.processedRecords = Math.min((i + concurrentLimit) * this.batchSize, this.tableData.length);
          this.saveProgress = Math.round((this.processedRecords / this.tableData.length) * 100);
          this.currentBatch = Math.floor(this.processedRecords / this.batchSize) + 1;
        }
      },

      async processBatch(batchData, batchIndex) {
        const formattedData = this.formatDataForApi(batchData);
        let retries = 0;

        while (retries <= this.retryCount) {
          try {
            const param = {
              company_id: sessionStorage.getItem('company_id'),
              access_token: sessionStorage.getItem('token'),
              proxy_id: this.form.proxy_id,
              pay_source_id: this.form.pay_source_id,
              pay_time: this.form.pay_time,
              data_list: formattedData
            };

            if (this.enableCompression) {
              // 可以在这里添加数据压缩逻辑
              param.compressed = true;
            }

            const startTime = Date.now();
            const response = await this.$axios.payIcbcSaveAll(param);
            const duration = Date.now() - startTime;

            // 更新统计
            this.apiStats.totalRequests++;
            this.apiStats.avgResponseTime =
                    (this.apiStats.avgResponseTime * (this.apiStats.totalRequests - 1) + duration) / this.apiStats.totalRequests;

            if (response.code === 200) {
              this.apiStats.successRequests++;
              this.addApiLog(`批次 ${batchIndex + 1} 保存成功: ${response.data.success} 成功, ${response.data.failed} 失败`, 'info');

              // 记录失败记录
              if (response.data.failed_details && response.data.failed_details.length > 0) {
                response.data.failed_details.forEach((failed, idx) => {
                  this.failedRecords.push({
                    batch: batchIndex,
                    index: idx,
                    data: formattedData[idx],
                    error: failed.error
                  });
                  this.errorDetails.push({
                    batch: batchIndex + 1,
                    index: idx + batchIndex * this.batchSize,
                    message: failed.error,
                    data: formattedData[idx]
                  });
                });
              }

              return; // 成功，退出重试循环
            } else {
              throw new Error(response.msg || '保存失败');
            }

          } catch (error) {
            retries++;
            this.totalRetries++;

            if (retries <= this.retryCount) {
              this.addApiLog(`批次 ${batchIndex + 1} 第 ${retries} 次重试: ${error.message}`, 'warning');

              // 指数退避
              const delay = Math.pow(2, retries) * 1000;
              await new Promise(resolve => setTimeout(resolve, delay));
            } else {
              this.apiStats.failedRequests++;
              this.addApiLog(`批次 ${batchIndex + 1} 最终失败: ${error.message}`, 'error');

              // 记录整个批次失败
              batchData.forEach((record, idx) => {
                this.failedRecords.push({
                  batch: batchIndex,
                  index: idx,
                  data: record,
                  error: error.message
                });
              });

              throw error;
            }
          }
        }
      },

      // 重试失败记录
      async retryFailedRecords() {
        if (this.failedRecords.length === 0) {
          this.$message.warning('没有失败记录需要重试');
          return;
        }

        this.retryingFailed = true;

        try {
          // 按批次分组
          const batchMap = new Map();
          this.failedRecords.forEach(record => {
            if (!batchMap.has(record.batch)) {
              batchMap.set(record.batch, []);
            }
            batchMap.get(record.batch).push(record.data);
          });

          // 重新处理每个失败批次
          for (const [batchIndex, records] of batchMap.entries()) {
            await this.processBatch(records, batchIndex);
          }

          this.$message.success('失败记录重试完成');
          this.failedRecords = [];
          this.errorDetails = [];

        } catch (error) {
          this.$message.error('重试失败记录时出错');
        } finally {
          this.retryingFailed = false;
        }
      },

      // 文件大小估算
      async estimateFileSize() {
        if (!this.file) return;

        try {
          if (this.activeTab === 'csv') {
            await this.estimateCSVRows();
          } else {
            await this.estimateExcelRows();
          }
        } catch (error) {
          console.error('估算文件大小失败:', error);
        }
      },

      async estimateCSVRows() {
        return new Promise((resolve) => {
          let rowCount = 0;

          Papa.parse(this.file, {
            header: false,
            skipEmptyLines: true,
            preview: 1000,
            step: (results) => {
              console.log(results)
              rowCount++;
            },
            complete: () => {
              // 基于样本估算总行数
              const fileSize = this.file.size;
              const sampleSize = 1000;
              console.log(sampleSize)
              const estimatedTotal = Math.floor((rowCount * fileSize) / (this.file.type === 'text/csv' ? 100 : 1024));
              this.estimatedRowCount = estimatedTotal;
              this.$message.info(`估算文件包含约 ${estimatedTotal.toLocaleString()} 条记录`);
              resolve();
            }
          });
        });
      },

      // 其他辅助方法
      formatSpeed(bytesPerSecond) {
        if (bytesPerSecond < 1024) return `${bytesPerSecond} B/s`;
        if (bytesPerSecond < 1024 * 1024) return `${(bytesPerSecond / 1024).toFixed(1)} KB/s`;
        return `${(bytesPerSecond / (1024 * 1024)).toFixed(1)} MB/s`;
      },

      formatTime(seconds) {
        if (seconds < 60) return `${Math.round(seconds)}秒`;
        if (seconds < 3600) return `${Math.floor(seconds / 60)}分${Math.round(seconds % 60)}秒`;
        return `${Math.floor(seconds / 3600)}小时${Math.floor((seconds % 3600) / 60)}分`;
      },

      formatDuration(seconds) {
        return this.formatTime(seconds);
      },

      // 原有方法保持不变，但添加性能考虑
      processFile() {
        if (this.performanceMode === 'standard') {
          this.parseFile();
        } else {
          this.parseLargeFile();
        }
      },

      // ... 其他原有方法保持基本不变，但可以在适当位置添加性能优化 ...
      // 解析文件
      parseFile() {
        const fileReader = new FileReader();
        const fileExtension = this.file.name.split('.').pop().toLowerCase();

        fileReader.onload = (e) => {
          try {
            if (fileExtension === 'csv') {
              // 处理CSV文件
              if (typeof Papa === 'undefined') {
                this.$message.error('CSV解析库未正确加载，请刷新页面重试');
                return;
              }

              const csvData = Papa.parse(e.target.result, {
                header: true,
                skipEmptyLines: true,
                encoding: 'UTF-8'
              });

              if (csvData.data.length > 0) {
                this.tableHeader = Object.keys(csvData.data[0]);
                this.tableData = csvData.data;
                this.uploadSuccess = true;
                this.$message.success('CSV文件解析成功！');
                this.addApiLog(`CSV文件解析成功，共 ${csvData.data.length} 条记录`, 'info');
              } else {
                this.$message.error('CSV文件中没有数据');
                this.addApiLog('CSV文件中没有数据', 'error');
              }
            } else {
              // 处理Excel文件
              const data = new Uint8Array(e.target.result);
              const workbook = XLSX.read(data, {type: 'array'});

              const firstSheetName = workbook.SheetNames[0];
              const worksheet = workbook.Sheets[firstSheetName];

              // 转换为JSON
              const jsonData = XLSX.utils.sheet_to_json(worksheet);

              if (jsonData.length > 0) {
                // 获取表头
                this.tableHeader = Object.keys(jsonData[0]);
                this.tableData = jsonData;
                this.uploadSuccess = true;
                this.$message.success('Excel文件解析成功！');
                this.addApiLog(`Excel文件解析成功，共 ${jsonData.length} 条记录`, 'info');
              } else {
                this.$message.error('Excel文件中没有数据');
                this.addApiLog('Excel文件中没有数据', 'error');
              }
            }

            // 初始化字段映射
            this.initFieldMappings();
          } catch (err) {
            console.error(err);
            this.$message.error('文件解析失败：' + err.message);
            this.addApiLog('文件解析失败: ' + err.message, 'error');
          }
        };

        if (fileExtension === 'csv') {
          fileReader.readAsText(this.file, 'UTF-8');
        } else {
          fileReader.readAsArrayBuffer(this.file);
        }
      },
      formatFileSize(size) {
        if (size < 1024) {
          return size + ' B';
        } else if (size < 1024 * 1024) {
          return (size / 1024).toFixed(2) + ' KB';
        } else if (size < 1024 * 1024 * 1024) {
          return (size / (1024 * 1024)).toFixed(2) + ' MB';
        } else {
          return (size / (1024 * 1024 * 1024)).toFixed(2) + ' GB';
        }
      },
      // 将数据格式化为API所需格式
      formatDataForApi(data) {
        return data.map(item => {
          const apiItem = {};

          // 根据字段映射转换数据
          for (const sourceField in this.fieldMappings) {
            const targetField = this.fieldMappings[sourceField];
            if (targetField && item[sourceField] !== undefined) {
              apiItem[targetField] = item[sourceField];
            }
          }

          return apiItem;
        });
      },
      // 测试API接口
      testApi() {
        this.addApiLog('测试API接口连接...', 'info');

        // 模拟API测试
        setTimeout(() => {
          this.addApiLog('API接口测试成功', 'info');
          this.$message.success('API接口测试成功');
        }, 800);
      },

      // 处理文件变化
      handleFileChange(file) {


        this.file = file.raw;
        this.uploadSuccess = false;
        this.tableData = [];

        if (!this.file) {
          this.$message.error('请选择文件');
          return;
        }

        // 解析文件
        this.parseFile();
      },
      // 初始化字段映射
      initFieldMappings() {
        this.fieldMappings = {};


        this.tableHeader.forEach(header => {


          // 尝试自动匹配字段
          const lowerHeader = header.toLowerCase();
          if(this.form.pay_source_id==7){//工行支付
            let matchedField = null;
            if (lowerHeader.includes('cusid') || lowerHeader.includes('商户号') || lowerHeader.includes('编号')) {
              matchedField = 'cusid';
            } else if (lowerHeader.includes('service_cusid') || lowerHeader.includes('服务商号')) {
              matchedField = 'service_cusid';
            }  else if (lowerHeader.includes('balance') || lowerHeader.includes('分润')) {
              matchedField = 'balance';
            }
            else if (lowerHeader.includes('merchant_name') || lowerHeader.includes('商户名称')) {
              matchedField = 'merchant_name';
            }

            // else if (lowerHeader.includes('servince_name') || lowerHeader.includes('服务商名称')) {
            //   matchedField = 'servince_name';
            // } else if (lowerHeader.includes('merchant') || lowerHeader.includes('商户')) {
            //   matchedField = 'merchant';
            // } else if (lowerHeader.includes('method') || lowerHeader.includes('方式')) {
            //   matchedField = 'paymentMethod';
            // }
            this.fieldMappings[header] = matchedField;
          }else if(this.form.pay_source_id==5){//易宝支付
            let matchedField = null;
            // if (lowerHeader.includes('cusid') || lowerHeader.includes('编号')) {
            //   matchedField = 'cusid';
            // } else
            if (lowerHeader.includes('cusid') || lowerHeader.includes('商户编号')) {
              matchedField = 'cusid';
            }  else if (lowerHeader.includes('balance') || lowerHeader.includes('分润金额')) {
              matchedField = 'balance';
            }  else if (lowerHeader.includes('product_type') || lowerHeader.includes('产品类型')) {
              matchedField = 'product_type';
            }else if (lowerHeader.includes('amount') || lowerHeader.includes('交易金额')) {
              matchedField = 'amount';
            } else if (lowerHeader.includes('trade_time') || lowerHeader.includes('交易日期')) {
              matchedField = 'trade_time';
            }
            else if (lowerHeader.includes('merchant_name') || lowerHeader.includes('商户名称')) {
              matchedField = 'merchant_name';
            }
            // else if (lowerHeader.includes('servince_name') || lowerHeader.includes('服务商名称')) {
            //   matchedField = 'servince_name';
            // } else if (lowerHeader.includes('merchant') || lowerHeader.includes('商户')) {
            //   matchedField = 'merchant';
            // } else if (lowerHeader.includes('method') || lowerHeader.includes('方式')) {
            //   matchedField = 'paymentMethod';
            // }
            this.fieldMappings[header] = matchedField;
          }else if(this.form.pay_source_id==11){//盛付通
            let matchedField = null;
            // if (lowerHeader.includes('cusid') || lowerHeader.includes('编号')) {
            //   matchedField = 'cusid';
            // } else
            if (lowerHeader.includes('cusid') || lowerHeader.includes('商户号')) {
              matchedField = 'cusid';
            }   else if (lowerHeader.includes('balance') || lowerHeader.includes('本级实收分润')) {
              matchedField = 'balance';
            } else if (lowerHeader.includes('balance') || lowerHeader.includes('收单分润')) {
              matchedField = 'balance';
            } else if (lowerHeader.includes('amount') || lowerHeader.includes('交易金额')) {
              matchedField = 'amount';
            } else if (lowerHeader.includes('trade_time') || lowerHeader.includes('交易时间')) {
              matchedField = 'trade_time';
            } else if (lowerHeader.includes('trade_time') || lowerHeader.includes('汇总周期')) {
              matchedField = 'trade_time';
            }else if (lowerHeader.includes('way_code') || lowerHeader.includes('支付方式')) {
              matchedField = 'way_code';
            }else if (lowerHeader.includes('merchant_name') || lowerHeader.includes('商户名称')) {
              matchedField = 'merchant_name';
            }
            else if (lowerHeader.includes('trade_no') || lowerHeader.includes('盛付通订单号')) {
              matchedField = 'trade_no';
            }
            // else if (lowerHeader.includes('merchant') || lowerHeader.includes('商户')) {
            //   matchedField = 'merchant';
            // } else if (lowerHeader.includes('method') || lowerHeader.includes('方式')) {
            //   matchedField = 'paymentMethod';
            // }
            this.fieldMappings[header] = matchedField;
          }else if(this.form.pay_source_id==19){//乐刷
            let matchedField = null;
            // if (lowerHeader.includes('cusid') || lowerHeader.includes('编号')) {
            //   matchedField = 'cusid';
            // } else
            if (lowerHeader.includes('cusid') || lowerHeader.includes('商户编号')) {
              matchedField = 'cusid';
            }   else if (lowerHeader.includes('balance') || lowerHeader.includes('分润总额')) {
              matchedField = 'balance';
            } else if (lowerHeader.includes('amount') || lowerHeader.includes('应结订单金额')) {
              matchedField = 'amount';
            } else if (lowerHeader.includes('trade_time') || lowerHeader.includes('创建时间')) {
              matchedField = 'trade_time';
            }else if (lowerHeader.includes('way_code') || lowerHeader.includes('交易类型')) {
              matchedField = 'way_code';
            }else if (lowerHeader.includes('merchant_name') || lowerHeader.includes('商户简称')) {
              matchedField = 'merchant_name';
            }
            else if (lowerHeader.includes('trade_no') || lowerHeader.includes('交易单号')) {
              matchedField = 'trade_no';
            }
            // else if (lowerHeader.includes('merchant') || lowerHeader.includes('商户')) {
            //   matchedField = 'merchant';
            // } else if (lowerHeader.includes('method') || lowerHeader.includes('方式')) {
            //   matchedField = 'paymentMethod';
            // }
            this.fieldMappings[header] = matchedField;
          }

        });
      },

      // 显示字段映射对话框
      showMappingDialog() {
        if (this.tableData.length === 0) {
          this.$message.warning('没有数据可映射');
          return;
        }

        this.mappingDialogVisible = true;
      },
// 确认字段映射
      confirmMapping() {
        // 检查是否所有字段都已映射
        const unmappedFields = Object.values(this.fieldMappings).filter(value => !value);

        if (unmappedFields.length > 0) {
          this.$message.warning('请映射所有字段');
          return;
        }

        this.mappingDialogVisible = false;
        this.$message.success('字段映射配置已保存');
        this.addApiLog('字段映射配置已保存', 'info');
      },
      // 导出数据优化
      async exportData() {
        if (this.tableData.length === 0) {
          this.$message.warning('没有数据可导出');
          return;
        }

        if (this.tableData.length > 50000) {
          await this.$confirm(`导出 ${this.tableData.length.toLocaleString()} 条记录可能需要较长时间，是否继续？`, '导出提示', {
            confirmButtonText: '继续',
            cancelButtonText: '取消',
            type: 'warning'
          });
        }

        this.exporting = true;

        try {
          // 分批导出，防止内存溢出
          const chunkSize = 50000;
          const chunks = Math.ceil(this.tableData.length / chunkSize);

          if (chunks > 1) {
            for (let i = 0; i < chunks; i++) {
              const start = i * chunkSize;
              const end = Math.min(start + chunkSize, this.tableData.length);
              const chunkData = this.tableData.slice(start, end);

              const worksheet = XLSX.utils.json_to_sheet(chunkData);
              const workbook = XLSX.utils.book_new();
              XLSX.utils.book_append_sheet(workbook, worksheet, `数据_${i+1}`);

              if (i === 0) {
                XLSX.writeFile(workbook, `支付流水数据_部分${i+1}.xlsx`);
              } else {
                // 可以在这里实现多sheet导出或分文件导出
                this.$message.info(`第 ${i+1} 部分数据已处理`);
              }
            }
            this.$message.success('数据分批导出完成！');
          } else {
            const worksheet = XLSX.utils.json_to_sheet(this.tableData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "支付流水数据");
            XLSX.writeFile(workbook, "支付流水数据.xlsx");
            this.$message.success('数据导出成功！');
          }

          this.addApiLog('数据已导出到Excel文件', 'info');
        } catch (error) {
          this.$message.error(`导出失败: ${error.message}`);
        } finally {
          this.exporting = false;
        }
      },

      // ... 其他原有方法 ...
// 清空数据
      clearData() {
        this.$confirm('确定要清空所有数据吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.tableData = [];
          this.tableHeader = [];
          this.uploadSuccess = false;
          this.file = null;
          this.apiResponse = null;
          this.$message.info('已清空数据');
          this.addApiLog('已清空上传的数据', 'info');
        }).catch(() => {
          this.$message.info('已取消清空操作');
        });
      },
      // 切换API连接状态
      toggleApiConnection() {
        this.apiConnected = !this.apiConnected;

        if (this.apiConnected) {
          this.$message.success('API连接已建立');
          this.addApiLog('API连接已建立', 'info');
        } else {
          this.$message.warning('API连接已断开');
          this.addApiLog('API连接已断开', 'warning');
        }
      },

      // 添加API日志
      addApiLog(message, type = 'info') {
        this.apiLogs.unshift({
          time: new Date().toLocaleTimeString(),
          message: message,
          type: type
        });

        // 限制日志数量
        if (this.apiLogs.length > 50) {
          this.apiLogs = this.apiLogs.slice(0, 50);
        }
      },

      // 原有方法保持不变
      changeRoleNameValue(e) {
        console.log(e);
      },

      okForm() {
        if (this.form.pay_source_id === '') {
          this.$message.warning('请选择支付渠道');
          return;
        }
        if (this.form.proxy_id === '') {
          this.$message.warning('请选择代理商');
          return;
        }
        if (this.form.pay_time === '') {
          this.$message.warning('请选择支付月份');
          return;
        }
        this.is_show = true;
      },

      closeForm2() {
        this.visible2 = false;
      },

      cProxy() {
        this.title2 = "选择所属代理";
        this.visible2 = true;
        this.formData2.pid = sessionStorage.getItem('proxy_id');
      },

      chooseProxy(id, ...params) {
        this.form.proxy_id = id;
        this.form.proxy_name = params[0];
      },

      getProxyList() {
        const param = {
          company_id: sessionStorage.getItem('company_id'),
          access_token: sessionStorage.getItem('token'),
        };
        this.$axios.findPaySourceList(param).then(res => {
          if (res.code == 200) {
            this.paySourceList = res.data;
          }
        }).catch(error => {
          console.log(error);
        });
      },

      // ... 其他原有方法 ...
    }
  };
</script>

<style scoped>
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", Arial, sans-serif;
  }

  body {
    background-color: #f5f7fa;
    color: #606266;
    padding: 20px;
  }

  .container {
    max-width: 1200px;
    margin: 0 auto;
  }

  .header {
    text-align: center;
    margin-bottom: 30px;
    padding: 20px;
    background: linear-gradient(135deg, #67c23a 0%, #85ce61 100%);
    border-radius: 8px;
    color: white;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  .header h1 {
    font-size: 28px;
    margin-bottom: 10px;
  }

  .header p {
    font-size: 16px;
    opacity: 0.9;
  }

  .main-content {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    margin-bottom: 20px;
  }

  .upload-section, .preview-section, .api-section {
    flex: 1;
    min-width: 300px;
    background: white;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }

  .api-section {
    min-width: 100%;
  }

  .section-title {
    font-size: 18px;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ebeef5;
    color: #67c23a;
    display: flex;
    align-items: center;
  }

  .section-title i {
    margin-right: 10px;
  }

  .upload-demo {
    text-align: center;
  }

  .el-upload-dragger {
    width: 100% !important;
    padding: 20px;
  }

  .upload-tips {
    margin-top: 15px;
    color: #909399;
    font-size: 14px;
    line-height: 1.6;
  }

  .upload-tips p:first-child {
    font-weight: 500;
    margin-bottom: 5px;
  }

  .preview-table {
    margin-top: 20px;
    width: 100%;
  }

  .action-buttons {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    gap: 15px;
    flex-wrap: wrap;
  }

  .footer {
    margin-top: 30px;
    text-align: center;
    color: #909399;
    font-size: 14px;
  }

  .no-data {
    text-align: center;
    padding: 40px 0;
    color: #909399;
  }

  .no-data i {
    font-size: 60px;
    margin-bottom: 15px;
    display: block;
    color: #ebeef5;
  }

  .success-message {
    background-color: #f0f9eb;
    color: #67c23a;
    padding: 15px;
    border-radius: 4px;
    margin-top: 20px;
    display: flex;
    align-items: center;
  }

  .success-message i {
    margin-right: 10px;
    font-size: 18px;
  }

  .file-info {
    margin-top: 15px;
    padding: 10px;
    background-color: #f5f7fa;
    border-radius: 4px;
    font-size: 14px;
  }

  .api-panel {
    margin-top: 20px;
  }

  .api-status {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    padding: 10px;
    border-radius: 4px;
    background-color: #f5f7fa;
  }

  .status-indicator {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-right: 10px;
  }

  .status-connected {
    background-color: #67c23a;
  }

  .status-disconnected {
    background-color: #f56c6c;
  }

  .api-stats {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    margin: 20px 0;
  }

  .stat-card {
    flex: 1;
    min-width: 150px;
    background: white;
    border-radius: 8px;
    padding: 15px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    text-align: center;
  }

  .stat-value {
    font-size: 24px;
    font-weight: bold;
    color: #67c23a;
    margin: 10px 0;
  }

  .stat-label {
    font-size: 14px;
    color: #909399;
  }

  .api-operations {
    margin-top: 20px;
  }

  .api-log {
    margin-top: 20px;
    max-height: 200px;
    overflow-y: auto;
    padding: 10px;
    background-color: #f5f7fa;
    border-radius: 4px;
    font-family: monospace;
    font-size: 13px;
  }

  .log-entry {
    margin-bottom: 5px;
    padding: 5px;
    border-left: 3px solid #67c23a;
    background-color: white;
  }

  .log-error {
    border-left-color: #f56c6c;
    color: #f56c6c;
  }

  .log-warning {
    border-left-color: #e6a23c;
    color: #e6a23c;
  }

  .api-progress {
    margin-top: 20px;
  }

  .progress-info {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    font-size: 14px;
    color: #909399;
  }

  @media (max-width: 768px) {
    .main-content {
      flex-direction: column;
    }

    .action-buttons {
      flex-direction: column;
      align-items: center;
    }

    .action-buttons .el-button {
      width: 100%;
      margin-bottom: 10px;
    }
  }

  .file-type-tabs {
    display: flex;
    margin-bottom: 15px;
    border-bottom: 1px solid #ebeef5;
  }

  .file-type-tab {
    padding: 10px 20px;
    cursor: pointer;
    border-bottom: 2px solid transparent;
  }

  .file-type-tab.active {
    color: #67c23a;
    border-bottom: 2px solid #67c23a;
    font-weight: 500;
  }

  .data-mapping {
    margin-top: 20px;
  }

  .mapping-row {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    padding: 10px;
    background-color: #f5f7fa;
    border-radius: 4px;
  }

  .source-field, .target-field {
    flex: 1;
    padding: 8px;
    background: white;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
  }

  .mapping-arrow {
    margin: 0 15px;
    color: #67c23a;
  }

  .response-details {
    margin-top: 20px;
    padding: 15px;
    background-color: #f5f7fa;
    border-radius: 4px;
  }

  .response-item {
    margin-bottom: 10px;
    padding: 10px;
    background: white;
    border-radius: 4px;
    border-left: 3px solid #67c23a;
  }

  .response-error {
    border-left-color: #f56c6c;
  }
  /* 添加新样式 */
  .performance-tips {
    margin: 15px 0;
  }

  .performance-mode {
    background: white;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 20px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }

  .mode-description {
    margin-top: 15px;
    padding: 15px;
    background-color: #f5f7fa;
    border-radius: 4px;
  }

  .mode-description p {
    margin: 5px 0;
    color: #606266;
  }

  .large-file-config {
    margin: 15px 0;
  }

  .config-row {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    flex-wrap: wrap;
  }

  .config-label {
    width: 150px;
    font-size: 14px;
    color: #606266;
  }

  .config-tip {
    margin-left: 15px;
    font-size: 12px;
    color: #909399;
  }

  .chunk-progress {
    margin: 15px 0;
  }

  .chunk-details {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    font-size: 12px;
    color: #909399;
  }

  .chunk-info {
    margin-left: 10px;
    font-size: 12px;
    color: #67c23a;
  }

  .memory-monitor {
    margin: 15px 0;
    padding: 10px;
    background-color: #f5f7fa;
    border-radius: 4px;
  }

  .memory-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .memory-info span {
    font-size: 14px;
    color: #606266;
  }

  .streaming-notice {
    margin-bottom: 15px;
  }

  .performance-monitor {
    display: flex;
    justify-content: space-between;
    margin: 15px 0;
    padding: 15px;
    background: linear-gradient(135deg, #f5f7fa 0%, #e4e7ed 100%);
    border-radius: 8px;
  }

  .monitor-row {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .monitor-row span:first-child {
    font-size: 12px;
    color: #909399;
    margin-bottom: 5px;
  }

  .monitor-value {
    font-size: 18px;
    font-weight: bold;
    color: #67c23a;
  }

  .failed-records {
    margin: 15px 0;
  }

  .phase-progress {
    margin: 20px 0;
  }

  .phase-title {
    text-align: center;
    margin-bottom: 15px;
    font-weight: 500;
    color: #606266;
  }

  .progress-text {
    font-size: 12px;
  }

  .error-details {
    margin-top: 15px;
  }

  .error-item {
    margin-bottom: 10px;
    padding: 10px;
    border-left: 3px solid #f56c6c;
    background-color: #fef0f0;
    border-radius: 4px;
  }

  .error-item p {
    margin: 5px 0;
    font-size: 13px;
    color: #f56c6c;
  }

  /* 响应式调整 */
  @media (max-width: 768px) {
    .performance-monitor {
      flex-direction: column;
    }

    .monitor-row {
      margin-bottom: 10px;
    }

    .config-row {
      flex-direction: column;
      align-items: flex-start;
    }

    .config-label {
      margin-bottom: 5px;
    }
  }
</style>
